<template>
    <div :class="[[...containerClass], 'checkbox-component']">
        <input
            :id="id"
            v-model="configValues"
            :class="[[...inputClass], 'checkbox']"
            type="checkbox"
            :value="value"
            :disabled="disabled"
        >
        <label :for="id" :class="[...labelClass]">
            <template v-if="!! $slots.default">
                <slot />
            </template>
            <template v-else>
                {{ label }}
            </template>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        values: {
            type: [Array, Boolean],
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        value: {
            type: [String, Boolean],
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        containerClass: {
            type: Array,
            default: () => [],
        },
        inputClass: {
            type: Array,
            default: () => [],
        },
        labelClass: {
            type: Array,
            default: () => [],
        },
        isPro: {
            type: Boolean,
            default: () => false,
        },
        id: {
            type: String,
            default: null,
        },
    },

    computed: {
        configValues: {
            /**
             * Get value
             *
             * @returns {Array} Values for checkboxes in group
             */
            get() {
                return this.values;
            },

            /**
             * Set value
             *
             * @param   {Array}  values  Modified array with values
             *
             */
            set(values) {
                this.$emit('change', values);
            },
        },
    },
};
</script>
